<template>
  <b-button 
    :disabled="busy" 
    variant="info" 
    size="sm" 
    @click="startDownload"
  >
    <font-awesome-icon icon="download" /> <font-awesome-icon 
      v-if="busy" 
      icon="spinner" 
      spin
    /> Download rapport
  </b-button>
</template>

<script>
    import { serviceMixin } from "@/mixins/serviceMixin";
    import { saveAs } from 'file-saver';
    export default {
        name: 'Download',
        components: {},
        mixins: [serviceMixin],
        props: {
            filename: {
                type: String,
                default: "oplevering.pdf"
            },
            downloadUrl: {
                type: String,
                default: null
            },
            mimeType: {
                type: String,
                default: "application/pdf"
            }
        },
        data() {
            return  {
                busy: false
            }
        },
        computed: {},
        watch: {},
        mounted () {
            
        },
        methods: {
            startDownload() {
                var vm = this;
                vm.busy=true;
                console.log(this.downloadUrl);
                this.getBlob(this.downloadUrl)
                .then(function(response) {
                    var blob = new Blob([response.data], { type: vm.mimeType });
                    if (response.headers['content-disposition']) {
                        var filename = response.headers['content-disposition'].split('filename=')[1];
                        saveAs(blob, filename);
                    } else {
                        saveAs(blob, vm.filename);
                    }
                    
                })
                .catch(function(error) {
                    console.log(error);
                })
                .finally(
                    this.busy = false
                );
            },   
        },
              
    }
</script>